// extracted by mini-css-extract-plugin
module.exports = {"inPage":"Tabs_inPage__3ow9D","modal":"Tabs_modal__1CeHa","filter":"Tabs_filter__2fbTg"};